import * as React from 'react';
import ModalContainer from 'react-modal-promise';
import {NavigateFunction, Outlet, useLocation, useMatch, useNavigate} from 'react-router';

import {ChromeHeaderReact} from 'common/widgets/chrome/chrome-header';
import {ReportMessageBannerReact} from 'common/widgets/report-message-banner';
import {ReportBannersReact} from 'common/widgets/report-banners';

function shouldHideHeader(pathname: string): boolean {
  const isEmbed = pathname.endsWith(`/embed`);
  const isPublic = pathname.startsWith(`/public`);
  const isDigest = pathname.startsWith(`/dashboard-digest`);
  return isEmbed || isPublic || isDigest;
}

export const Layout = ({
  children = <Outlet />,
  hideHeader = shouldHideHeader(window.location.pathname),
  navigate,
}: {
  children?: React.ReactNode;
  hideHeader?: boolean;
  navigate?: NavigateFunction;
}) => {
  if (hideHeader) {
    return <div id='mixpanel-application'>{children}</div>;
  }

  return (
    <>
      {/* mp-chrome-header uses shadow dom, so all its children will be in #shadow-root including styles */}
      {/* since we defer all js, these shell styles will be drawn as soon as css loads */}
      <ChromeHeaderReact navigate={navigate} />
      <div className='below_header'>
        <div id='width_wrapper'>
          <div id='report'>
            <div id='report_content' className='mp-chrome-report-content'>
              <div id='messages'>
                <ReportMessageBannerReact />
                <ReportBannersReact />
              </div>
              <div id='padding_wrapper'>
                <div id='mixpanel-application'>{children}</div>
              </div>
            </div>
          </div>
          <div id='modals' />
          <ModalContainer />
        </div>
      </div>
    </>
  );
};

export function RouterLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  // for spa mode + rewrite hash -> pathname, we need more specific handling for url like app/{appName}/nested/routes
  const isEmbedMode = useMatch(`/project/:projectId/view?/:workspaceId?/app/:appName/embed/*`);

  return <Layout hideHeader={shouldHideHeader(location.pathname) || !!isEmbedMode} navigate={navigate} />;
}
